import type { UserLikableImageMedia } from "@/schemas/user/image";

export function getValueFromSearchParams(
  params: Record<string, string | string[]>,
  parameterName: string,
): string | null {
  const value = params[parameterName];

  // Check if username exists in params
  if (value === undefined || value === null) {
    return null;
  }

  // Handle the case where it could be an array of strings
  if (Array.isArray(value)) {
    if (value[0] === undefined || value[0] === null) {
      return null;
    }
  }

  // Handle string case
  return params[parameterName] as string;
}

export function prepareImageDetailsNavigation(
  imageData: UserLikableImageMedia,
): {
  encodedImage: string;
  navigationParams: {
    params: { imageMedia: string };
    pathname: "/(main)/shared/image";
  };
} {
  const encodedImage = encodeURIComponent(JSON.stringify(imageData));
  return {
    encodedImage,
    navigationParams: {
      params: { imageMedia: encodedImage },
      pathname: "/(main)/shared/image",
    },
  };
}
